<template>
  <div class="importUsers">
    <BaseTitle titleText="匯入用戶資料" />
    <section class="importUsers__header">
      <div
        v-if="fileName"
        class="importUsers__button importUsers__button__clear"
        @click="clearFile"
      >
        <ArrowRightIcon />
        <span>清除資料</span>
      </div>
      <label
        v-else
        class="importUsers__button importUsers__button__add"
        for="importFile"
      >
        <UploadIcon /><span>新增用戶資料</span>
        <input
          id="importFile"
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          @change="fileParse($event)"
        />
      </label>
    </section>
    <section v-if="fileName" class="importUsers__file-view">
      <div class="importUsers__file">
        <FileIcon />
        <span>{{ fileName }}</span>
      </div>
      <button
        class="importUsers__button importUsers__button__upload"
        v-if="dataAllPass && !uploading && !uploadResult"
        @click="uploadData"
      >
        <b-spinner
          v-if="uploading"
          class="mr-2"
          variant="primary"
          label="Spinning"
        ></b-spinner>
        上傳資料
      </button>
      <div v-if="uploadResult === 'y'" class="importUsers__upload-success">
        <SuccessIcon />
        <span>上傳成功</span>
      </div>
      <div v-if="uploadResult === 'n'" class="importUsers__upload-fail">
        <FailIcon />
        <span>上傳失敗</span>
      </div>
      <span v-if="!dataAllPass" class="importUsers__error-message"
        >*檔案資料有誤，請檢查格式後再重新匯入檔案</span
      >
    </section>
    <section class="importUsers__list">
      <b-table head-variant="light" hover :fields="usersHeaders" :items="users">
        <template #cell(class)="{ item }">
          <div>
            {{ `${classMap(Number(item.class))}（${item.class}）` }}
          </div>
        </template>
        <template #cell(areaType)="{ item }">
          <div>
            {{ `${areaTypeMap(Number(item.areaType))}（${item.areaType}）` }}
          </div>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';
import UploadIcon from '@/assets/images/upload.svg';
import ArrowRightIcon from '@/assets/images/arrow-right.svg';
import FileIcon from '@/assets/images/file.svg';
import SuccessIcon from '@/assets/images/circle-check.svg';
import FailIcon from '@/assets/images/circle-close.svg';

import { classMap, areaTypeMap } from '@/utils/optionMaps.js';
import parseSheet from '@/utils/fileDataParse';
import variant from '@/utils/variant.js';
import { mapActions } from 'vuex';
import { errorMessageParse } from '@/utils/errorMessage';

export default {
  name: 'ImportUsers',
  components: {
    BaseTitle,
    UploadIcon,
    ArrowRightIcon,
    FileIcon,
    SuccessIcon,
    FailIcon
  },
  data() {
    return {
      usersHeaders: [
        {
          key: 'name',
          label: '姓名'
        },
        {
          key: 'verification',
          label: '驗證'
        },
        {
          key: 'identityCode',
          label: '身分證號'
        },
        {
          key: 'class',
          label: '身份別'
        },
        {
          key: 'areaType',
          label: '區域類型'
        },
        {
          key: 'address',
          label: '地址'
        },
        {
          key: 'contactPerson',
          label: '聯絡人'
        },
        {
          key: 'telephoneNumber',
          label: '電話1'
        },
        {
          key: 'mobilePhoneNumber1',
          label: '電話2'
        },
        {
          key: 'mobilePhoneNumber2',
          label: '電話2'
        }
      ],
      users: [],
      fileName: null,
      parsingFile: false,
      dataAllPass: true,
      uploading: false,
      uploadResult: null
    };
  },
  methods: {
    ...mapActions({
      uploadUsers: 'longTerm/uploadUsers'
    }),
    classMap(value) {
      if (classMap(value) === '請選擇') {
        return '';
      }
      return classMap(value);
    },
    areaTypeMap(value) {
      if (areaTypeMap(value) === '請選擇') {
        return '';
      }
      return areaTypeMap(value);
    },
    async fileParse(e) {
      const data = await parseSheet(e.target.files[0]);
      // 確定輸入的是用戶資料
      if (Object.prototype.hasOwnProperty.call(data[0], 'verification')) {
        this.parsingFile = true;
        this.fileName = e.target.files[0].name;
        this.users = this.dataVariant(data);
      } else {
        this.$store.commit('errorMessage', '請上傳正確的用戶資料');
        this.$root.$emit('bv::show::modal', 'error-modal');
        this.fileName = null;
        this.parsingFile = false;
      }

      this.parsingFile = false;
    },
    clearFile() {
      this.users = [];
      this.fileName = null;
      this.parsingFile = false;
      this.dataAllPass = true;
      this.uploadResult = null;
    },
    dataVariant(data) {
      const newData = data.map(item => {
        const dataPass = Object.keys(item).every(key => {
          return this.variantRules(key, item[key]);
        });
        if (dataPass) return item;
        else {
          this.dataAllPass = false;
          return { ...item, _rowVariant: 'danger' };
        }
      });
      return newData;
    },
    variantRules(key, value) {
      if (key === 'verification') return variant.verification(value);
      if (key === 'identityCode') return variant.identifyCode(value);
      if (key === 'class') return variant.zeroOneTwo(value);
      if (key === 'areaType') return variant.zeroOneTwo(value);
      if (key === 'telephoneNumber') return variant.tel(value);
      if (key.indexOf('mobilePhoneNumber') > -1)
        return value ? variant.mobile(value) : true;
      return true;
    },
    parseVerification(value) {
      if (value === 'Y') return true;
      if (value === 'N') return false;
    },
    async uploadData() {
      this.uploading = true;
      const data = this.users.map(user => {
        return {
          ...user,
          class: Number(user.class),
          areaType: Number(user.areaType),
          verification: this.parseVerification(user.verification)
        };
      });
      try {
        await this.uploadUsers({
          datas: data
        });
        this.uploading = false;
        this.uploadResult = 'y';
      } catch (err) {
        this.uploading = false;
        this.uploadResult = 'n';
        console.warn('err', err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.importUsers {
  &__header {
    background-color: #edf0f4;
    padding: 20px 35px;
  }
  &__button {
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 10px 20px;
    margin-bottom: 0;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    &__add {
      background-color: $white;
      color: $black;
    }
    &__clear {
      background-color: $negative;
      color: $white;
    }
    &__upload {
      background-color: $positive;
      color: $white;
      border: none;
    }
    svg {
      margin-right: 5px;
    }
  }
  &__file {
    display: flex;
    align-items: center;
    width: fit-content;
    color: $black;
    margin-right: 50px;
    font-size: 1rem;
    svg {
      margin-right: 5px;
    }
    &-view {
      display: flex;
      align-items: center;
      padding: 0 35px;
      margin-top: 30px;
    }
  }
  &__error-message {
    margin-left: 10px;
    color: $negative;
  }
  &__list {
    padding: 30px 35px;
  }
  &__upload {
    &-success {
      display: flex;
      align-items: center;
      color: #00a65a;
      span {
        font-size: 1.1rem;
        margin-left: 5px;
      }
    }
    &-fail {
      display: flex;
      align-items: center;
      color: #ff0000;
      span {
        font-size: 1.1rem;
        margin-left: 5px;
      }
    }
  }
  #importFile {
    display: none;
  }
}
</style>
